import Check from "../Core/Check.js";
import DeveloperError from "../Core/DeveloperError.js";

/**
 * A bit flag describing whether a variable should be added to the
 * vertex shader, the fragment shader, or both (or none).
 *
 * @private
 */
const ShaderDestination = {
  NONE: 0,
  VERTEX: 1,
  FRAGMENT: 2,
  BOTH: 3
};

/**
 * Check if a variable should be included in the vertex shader.
 *
 * @param {ShaderDestination} destination The ShaderDestination to check
 * @return {boolean} <code>true</code> if the variable appears in the vertex shader, or <code>false</code> otherwise
 * @private
 */
ShaderDestination.includesVertexShader = function (destination) {
  return (destination & ShaderDestination.VERTEX) !== 0;
};

/**
 * Check if a variable should be included in the vertex shader.
 *
 * @param {ShaderDestination} destination The ShaderDestination to check
 * @return {boolean} <code>true</code> if the variable appears in the vertex shader, or <code>false</code> otherwise
 * @private
 */
ShaderDestination.includesFragmentShader = function (destination) {
  //

  return (destination & ShaderDestination.FRAGMENT) !== 0;
};

/**
 * Compute the union of multiple ShaderDestinations (e.g., VERTEX | FRAGMENT yields BOTH)
 * @param  {...ShaderDestination} destinations
 * @returns {ShaderDestination} The union of the provided destinations
 * @private
 */
ShaderDestination.union = function () {
  let result = 0;
  for (let i = 0; i < arguments.length; i++) {
    result |= i < 0 || arguments.length <= i ? undefined : arguments[i];
  }
  return result;
};

/**
 * Compute the intersection of multiple ShaderDestinations (e.g., VERTEX & FRAGMENT yields NONE)
 * @param  {...ShaderDestination} destinations
 * @returns {ShaderDestination} The intersection of the provided destinations
 * @private
 */
ShaderDestination.intersection = function () {
  let result = arguments.length <= 0 ? undefined : arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    result &= i < 0 || arguments.length <= i ? undefined : arguments[i];
  }
  return result;
};
export default Object.freeze(ShaderDestination);